import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledStickyContainer = styled.div<any>`
  ${({theme, disableMobile}) => `
    background: #ffffff;
    @keyframes fadeDown {
        from {padding-top: 0px ;}
        to {padding-top: 100px;}
    }

    &.sticky {
        ${
          !disableMobile
            ? `
            position:fixed;
            top: 0px;
            left: 0;
            z-index: 1;
            width: 100%;
            padding: 0 16px;
            display: flex;
            justify-content: space-between;
            -webkit-animation: fadeDown  0.3s ease-in 0s;
            -moz-animation: fadeDown 0.3s ease-in 0s;
            animation: fadeDown  0.3s ease-in 0s ;
            box-shadow: 0px 0px 8px 4px rgb(187 187 187 / 25%);
            padding-top: 100px;
            `
            : 'position: relative;'
        }
        @media screen and (min-width: ${Breakpoints.b960}px) {
            position: fixed;
            top: 0px;
            left: 0;
            z-index: 1;
            width: 100%;
            padding: 0 16px;
            display: flex;
            justify-content: center;
            -webkit-animation: fadeDown  0.3s ease-in 0s;
            -moz-animation: fadeDown 0.3s ease-in 0s;
            animation: fadeDown  0.3s ease-in 0s ;
            box-shadow: 0px 0px 8px 4px rgb(187 187 187 / 25%);
            padding: 0 ${theme.size.grid002};
            padding-top: 120px;
        }
    }

    &.non-sticky {
        position: relative;
    }
`}
`;

export const StyledStickyContentWrapper = styled.div`
  ${({theme}) => `
        width: 100%;
        max-width: calc(${Breakpoints.b2560}px - ${theme.size.grid004});
    `}
`;
